import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const { FiArrowLeft, FiArrowRight, FiStar } = FiIcons;
const reviews = [
  { name: 'Ananya Verma', area: 'Gomti Nagar', text: 'Such a lovely experience from start to finish. I showed them a picture for my haircut and they took the time to understand exactly what I wanted.' },
  { name: 'Ritika Srivastava', area: 'Hazratganj', text: 'The team made my engagement makeup feel like me, just a little more special. Everyone was warm and the finish lasted beautifully.' },
  { name: 'Aarav Mishra', area: 'Aliganj', text: 'Clean space, friendly staff and a great haircut. I appreciate that they listen instead of rushing through the appointment.' }
];

function Reviews() {
  const [active, setActive] = useState(0);
  const change = (step) => setActive((active + step + reviews.length) % reviews.length);
  const review = reviews[active];

  return (
    <section className="reviews-section">
      <div className="container reviews-grid">
        <Reveal><SectionHeading eyebrow="Kind words, honestly" title="A good visit is worth sharing." description="We're grateful to everyone who makes Saffron & Sage part of their routine." /></Reveal>
        <Reveal className="review-card" delay={0.1}>
          <div className="review-rating"><span>★★★★★</span><b>4.9</b><small>GOOGLE RATING</small></div>
          <blockquote>“{review.text}”</blockquote>
          <div className="review-bottom"><div><strong>{review.name}</strong><span>{review.area}, Lucknow</span></div><div className="review-controls"><button onClick={() => change(-1)} aria-label="Previous review"><SafeIcon icon={FiArrowLeft} /></button><button onClick={() => change(1)} aria-label="Next review"><SafeIcon icon={FiArrowRight} /></button></div></div>
          <div className="review-progress">{reviews.map((item, index) => <button aria-label={`Show review by ${item.name}`} className={index === active ? 'active' : ''} key={item.name} onClick={() => setActive(index)} />)}</div>
        </Reveal>
      </div>
    </section>
  );
}

export default Reviews;
